import { InspectorControls, useBlockProps } from "@wordpress/block-editor";

import AllInspectorSettings from "./InspectorControls";
import FormInputStylesControls, { getInputStyleVars } from '../../../components/FormInputStylesControls';

import "../style.scss";

export default function Edit(props) {
  return (
    <>
      <InspectorControls>
        <AllInspectorSettings {...props} />
        <FormInputStylesControls {...props} />
      </InspectorControls>
      <Content {...props} />
    </>
  );
}

export function Content({ attributes, isSave = false }) {
  const { name, isRequired, label, autocomplete, id, type, line } = attributes;

  const blockProps = isSave ? useBlockProps.save() : useBlockProps();
  const inputVars = getInputStyleVars(attributes.style && attributes.style.inputStyles);
  const Tag = type === "textarea" ? "textarea" : "input";
  return (
    <div {...blockProps} style={{ ...blockProps.style, ...inputVars }}>
      {label && (
        <label className="wp-block-brandy-form-label" htmlFor={id}>
          {label}{" "}
          {isRequired && (
            <abbr class="required" title="required">
              *
            </abbr>
          )}
        </label>
      )}
      <Tag
        className="wp-block-brandy-form-field"
        id={id}
        name={name}
        autocomplete={autocomplete ? "on" : "off"}
        required={isRequired}
        {...(type == "textarea"
          ? {
              rows: line,
            }
          : {
              type: "text",
            })}
      />
    </div>
  );
}
